import { useState, useCallback, useEffect } from 'react';
import { api, ApiError } from '../utils/apiClient';

export interface UsageData {
  count: number;
  limit: number;
  date: string;
}

interface UseUsageReturn {
  usage: UsageData | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useUsage(projectId?: string): UseUsageReturn {
  const [usage, setUsage] = useState<UsageData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUsage = useCallback(async () => {
    if (!projectId) return;

    setLoading(true);
    setError(null);

    try {
      const json = await api.get<{ data: UsageData }>(`/api/projects/${projectId}/usage`);
      setUsage(json.data);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Failed to fetch usage');
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  return { usage, loading, error, refetch: fetchUsage };
}
